
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { url } from 'inspector';

@Component({
  name: 'ImgLarge'
})
export default class extends Vue {
  private currentIndex: number = 0
  private carouselCount: number = 0
  private enlargedLoc:any = {}
  private rotate = true;

  get enlarged() {
    let urlArr = [];
    let len = AppModule.getEnlarged.imgList.length;
    for (let i = 0; i < len; i++) {
      if (AppModule.getEnlarged.imgList[i].media_type === '2') {
        urlArr.push({
          img_url: '',
          video_url: AppModule.getEnlarged.imgList[i].full_path,
          isRotate1: false,
          isRotate2: false,
          isRotate3: false
        });
      } else {
        urlArr.push({
          img_url: AppModule.getEnlarged.imgList[i].img_url ? AppModule.getEnlarged.imgList[i].img_url : AppModule.getEnlarged.imgList[i],
          video_url: AppModule.getEnlarged.imgList[i].video_url ? AppModule.getEnlarged.imgList[i].video_url : '',
          isRotate1: false,
          isRotate2: false,
          isRotate3: false
        });
      }
    }
    this.enlargedLoc = {
      imgList: urlArr
    };
    const res = {
      ...AppModule.getEnlarged
    };
    return res;
    // this.enlarged = res;
    // AppModule.getEnlarged.imgList = urlArr;
    // return AppModule.getEnlarged;
  }

  private close() {
    this.enlarged.isShow = false;
    this.carouselCount = 0;
    this.currentIndex = 0;
    this.$store.dispatch('toggleEnlarged', this.enlarged);
  }

  rotateHandle(val: number) {
    for (let i = 0; i < this.enlargedLoc.imgList.length; i++) {
      this.enlargedLoc.imgList[i].isRotate1 = false;
      this.enlargedLoc.imgList[i].isRotate2 = false;
      this.enlargedLoc.imgList[i].isRotate3 = false;
    }
    this.carouselCount++;
    if (this.carouselCount === 4) {
      this.carouselCount = 0;
    }
    switch (this.carouselCount) {
      case 1:
        this.enlargedLoc.imgList[val].isRotate1 = true;
        break;
      case 2:
        this.enlargedLoc.imgList[val].isRotate2 = true;
        break;
      case 3:
        this.enlargedLoc.imgList[val].isRotate3 = true;
        break;
      default:
        this.enlargedLoc.imgList[val].isRotate1 = false;
        this.enlargedLoc.imgList[val].isRotate2 = false;
        this.enlargedLoc.imgList[val].isRotate3 = false;
        break;
    }
  }

  carouselChangeHandle(index: number) {
    this.currentIndex = index;
    this.carouselCount = 0;
  }
}
